<!--
 * @title: 断板率
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/28 18:12
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <d2-container>
        <page-body v-show="!dialogShow"
                   :page-size="paging.limit"
                   :total="paging.total"
                   :current-page="paging.page"
                   @size-change="onPagingSizeChange"
                   @current-change="onPagingCurrentLimitChange">
            <template v-slot:default>
                <page-table
                        :buttons="buttons"
                        :table-column-attributes="pageConfig.tableColumnAttributes"
                        :value="tableData"
                        :toolbar-buttons="toolbarButtons"
                        :loading="loading"
                        @search-click="onSearch"
                        @add-click="onAdd"
                        @look-click="onLook"
                        @update-click="onUpdate"
                        @delete-click="onDelete"
                        :handle-column="true"
                >
                    <template v-slot:advanced-search>
                        <popover-form :form-config="searchConfig" v-model="search" @onSubmit="onSearch"></popover-form>
                    </template>
                </page-table>
            </template>
        </page-body>
        <page-edit-layout v-model="dataForm" v-show="dialogShow">
            <template v-slot:button>
                <div class="common-flex-center-end">
                    <el-button type="primary" v-if="operationType==1||operationType==2" @click="dataSubmit">计算并保存</el-button>
                    <el-button type="primary" @click="dialogShow = false">返回</el-button>
                </div>
            </template>
            <template v-slot>
                <divider title="断板率基础数据"></divider>
                <dynamic-form ref="dataForm" :form-config="dialogFormConfig" :disabled="!(operationType==1||operationType==2)" v-model="dataForm"></dynamic-form>
                <el-dialog :visible.sync="dialogTableVisible" width="80%" custom-class="dialogStyle">
                    <PavementPlanningManagement class="dialog-top" :tableUse="tableUses"></PavementPlanningManagement>
                </el-dialog>
                <divider title="明细信息"></divider>
                <div style="height: 25%;">
                    <page-table
                            :buttons="buttons"
                            :table-column-attributes="pageConfig.detailsTableColumnAttributes"
                            :value="pageConfig.detailsTableData"
                            :show-table-toolbar="false"
                            :loading="loading"
                            :handle-column="false"
                    >
                    </page-table>
                </div>
                <divider title="图示"></divider>
                <div style="height: 420px;" v-if="dialogShow" class="breaking-rate-eacharts-container">
                    <div class="echarts-container">
                        <ve-histogram :data-zoom="dataZoom" :legend-visible="false" :settings="chartSettings" :data="pageConfig.chartData"></ve-histogram>
                    </div>
                </div>
            </template>
        </page-edit-layout>
    </d2-container>
</template>

<script>
    import PageBody from "@/components/Pages/PageBody";
    import PageTable from "@/components/Pages/PageTable/index";
    import PageEditLayout from "@/components/Pages/layout/PageEditLayout";
    import PavementPlanningManagement from "@/views/decision/PavementPlanningManagement/index"

    export default {
        name: "index",
        components: {PageTable, PageBody, PageEditLayout, PavementPlanningManagement},
        data() {
            this.dataZoom = [
              {
                type: 'slider',
                start: 0,
                end: 100
              }
            ],
            this.chartSettings = {
              labelMap: {
                'dbl': '断板率',
              },
            }
            return {
                initializeForm:{},
                drivingRadio:"",
                dialogTableVisible: false,
                tableUses: {
                    //数据弹框
                    show: true,
                    size: "mini",
                    type: "success",
                    plain: true,
                    round: false,
                    circle: false,
                    loading: false,
                    disabled: false,
                    icon: "",
                    types: 1,
                    title: "使用",
                    name: "使用",
                    click: this.useRoute
                },
                //分页
                paging: {},
                //搜索数据
                search: {routeCode:""},
                //表格数据
                tableData: [],
                //页面配置
                pageConfig: {
                    // 表格列属性
                    tableColumnAttributes: [
                        {label: '规划批次名称', prop: 'partitionName', type: 'String', width: 'auto', children: []},
                        {label: '规划路线编码', prop: 'routeCode', type: 'String', width: 'auto', children: []},
                        {label: '规划路线名称', prop: 'routeName', type: 'String', width: 'auto', children: []},
                        {label: '检查批次编码', prop: 'testBatchName', type: 'String', width: 'auto', children: []},
                    ],
                    // 明细表
                    detailsTableColumnAttributes: [
                        {label: '养护路段编码', prop: 'sectionCode', type: 'String', width: 'auto', children: []},
                        {label: '行车方向', prop: 'drivingDirection', type: 'String', width: 'auto', children: []},
                        {label: '车道位置', prop: 'lane', type: 'String', width: 'auto', children: []},
                        {label: '起点桩号', prop: 'startStake', type: 'Stake', width: 'auto', children: []},
                        {label: '止点桩号', prop: 'endStake', type: 'Stake', width: 'auto', children: []},
                        {label: '断板率', prop: 'dbl', type: 'String', width: 'auto', children: []},
                    ],
                    detailsTableData: [],
                    chartData: {
                        columns: ['startStake', 'dbl'],
                        rows: [
                        ]
                    }
                },
                // 工具栏按钮
                toolbarButtons: this.ButtonEnums.BarButton.addButton,
                // 表格加载
                loading: false,
                // 查看模式
                lookModel: false,
                //操作类型
                operationType: 1,
                // 弹出层数据
                dataForm: {
                    rowCode: 0,
                    partitionId: 0,/// 路面规划管理id
                    partitionName: '',/// 路面规划管理名称
                    routeId: '',/// 路线id
                    routeCode: '',/// 路线编码
                    routeName: '',/// 路线名称
                    testBatchId: 0,/// 检测批次id
                    testBatchName: '',/// 检测批次名称
                    remark: '',
                    createUser: '',
                    createUserName: '',
                    createTime: '',
                    updateUser: '',
                    updateUserName: '',
                    updateTime: '',
                    status: '',
                    r1: '',
                    r2: '',
                    r3: '',
                    r4: '',
                    r5: '',
                    sublist: [],
                },
                dataChildForm:{
                    rowCode :0,
                    pCode :0,
                    sectionId :0,/// 养护路段id  int
                    sectionCode :'',/// 养护路段编码
                    curingType :'',/// 养护类型
                    drivingDirection :'',/// 行车方向
                    lane :'',/// 车道位置
                    startStake :'',/// 起点桩号    decimal
                    endStake :'',/// 止点桩号    decimal
                    dbl :'',/// 断板率  decimal
                    remark :'',/// 备注
                    createUser :'',
                    createUserName :'',
                    createTime :'',
                    updateUser :'',
                    updateUserName :'',
                    updateTime :'',
                    status :'',
                    r1 :'',
                    r2 :'',
                    r3 :'',
                    r4 :'',
                    r5 :'',
                },
                //搜索框配置
                searchConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "请输入路线编码",
                            "disabled": false,
                            "remoteFunc": "func_1590743826000_45116"
                        },
                        "name": "路线编码",
                        "key": "1590743839000_23510",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "路线编码格式不正确"}]
                    }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small", "customClass": ""}
                },
                // 弹出层表单配置
                dialogFormConfig: {
                    "list": [
                        {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": true,
                                "dataType": "string",
                                "pattern": "",
                                "placeholder": "请选择批次编码",
                                "disabled": false,
                                "remoteFunc": "func_1590656787000_34771",
                                onFocus: this.routeFileForm
                            },
                            "name": "规划批次名称",
                            "key": "1590657779000_42812",
                            "model": "partitionName",
                            "rules": [{"type": "string", "message": "规划批次名称格式不正确"}, {
                                "required": true,
                                "message": "规划批次名称必须填写"
                            }]
                        }, {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "dataType": "string",
                                "pattern": "",
                                "placeholder": "系统自动生成",
                                "disabled": true,
                                "remoteFunc": "func_1590738847000_1328"
                            },
                            "name": "路线名称",
                            "key": "1590738921000_36029",
                            "model": "routeName",
                            "rules": [{"type": "string", "message": "路线名称格式不正确"}]
                        }, {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "dataType": "string",
                                "pattern": "",
                                "placeholder": "系统自动生成",
                                "disabled": true,
                                "remoteFunc": "func_1590738847000_1328"
                            },
                            "name": "路线编码",
                            "key": "1590738847000_1328",
                            "model": "routeCode",
                            "rules": [{"type": "string", "message": "格式不正确"}]
                        }, {
                            "type": "input",
                            "icon": "icon-input",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "dataType": "string",
                                "pattern": "",
                                "placeholder": "系统自动生成",
                                "disabled": true,
                                "remoteFunc": "func_1590738847000_1328"
                            },
                            "name": "检测批次名称",
                            "key": "1590738847000_1328",
                            "model": "testBatchName",
                            "rules": [{"type": "string", "message": "格式不正确"}]
                        }, {
                            "type": "textarea",
                            "icon": "icon-diy-com-textarea",
                            "options": {
                                "width": "100%",
                                "defaultValue": "",
                                "required": false,
                                "disabled": false,
                                "pattern": "",
                                "placeholder": "请输入备注",
                                "remoteFunc": "func_1590738932000_15648"
                            },
                            "name": "备注",
                            "key": "1590738932000_15648",
                            "model": "remark",
                            "rules": []
                        }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small", "customClass": ""}
                },
                // 弹出层控制属性
                dialogShow: false
            }
        },
        methods: {
            //分页大小变更事件
            onPagingSizeChange(size) {
                this.paging.setSize(size)
                this.refreshData(this.paging, this.search)
            },
            // 分页当前页变动事件
            onPagingCurrentLimitChange(current) {
                this.paging.setIndex(current)
                this.refreshData(this.paging, this.search)
            },
            // 搜索事件
            onSearch() {
                this.refreshData(this.paging, this.search);
            },
            // 新增
            onAdd() {
                this.dialogShow = true;
                this.operationType = 1;
                this.dataForm = this.$formSetForm(this.initializeForm , this.initializeForm)
                this.pageConfig.detailsTableData=[];
                this.pageConfig.chartData.rows=[];
            },
            // 查看
            onLook(row) {
                this.$http.post(this.$url.routeDecision.getpmddbls,{rowCode:row.rowCode}).then(res=>{
                    this.operationType = 3;
                    this.dialogShow = true;
                    this.dataForm=res.data[0];
                    if(res.data[0].sublist){
                        this.pageConfig.detailsTableData=res.data[0].sublist;
                        this.pageConfig.chartData.rows=res.data[0].sublist;
                    }else{
                        this.pageConfig.detailsTableData=[];
                        this.pageConfig.chartData.rows=[];
                    }
                })
            },
            // 修改
            onUpdate() {

            },
            // 删除
            onDelete() {

            },
            initial() {
                this.refreshData(this.paging)
            },
            // 刷新数据
            refreshData(paging, search, callback) {
                const searchData = this.Tools.get().ObjectTools.merge(paging, search),
                    url = this.$url.routeDecision.getpmddbls
                // 由于web storm模板影响 请自行配置以下代码
                this.loading = true
                this.$http.post(url, searchData).then(res=>{
                    this.tableData=res.data;
                    this.paging.total = res.pageCount;
                    this.loading = false
                }).catch(error=>{
                    this.loading = false
                })
                
            },
            dataSubmit(){
                this.$refs.dataForm.submit().then(res => {
                    var forms = this.$formSetForm(this.dataForm, this.dataForm);
                    this.$http
                      .postHandle("保存", this.$url.routeDecision.operationpmddbl, {
                        pmdDbl: forms,
                      })
                      .then(res => {
                            this.operationType = 3;
                            this.dataForm=res.data;
                            this.pageConfig.detailsTableData=res.data.sublist;
                            this.pageConfig.chartData.rows=res.data.sublist;
                        // this.dialogShow = false;
                            this.refreshData(this.paging, this.search);
                      })
                      .catch(error => {
                        console.log(error);
                      });
                });
            },
            //规划管理使用
            routeFileForm() {
                this.dialogTableVisible = true;
            },
            useRoute(row, index) {
                this.dialogTableVisible = false
                this.dataForm.partitionName = row.planName
                this.dataForm.partitionId = row.rowCode
                this.dataForm.routeId = row.routeId
                this.dataForm.routeCode = row.routeCode
                this.dataForm.routeName = row.routeName
                this.dataForm.testBatchId = row.testBatchId
                this.dataForm.testBatchName = row.testBatchName
            }
        },
        computed: {
            // 表格按钮
            buttons() {
                return this.ButtonEnums.TableButtons.descriptionButton
            }
        },
        mounted() {
            this.paging = this.Paging.default()
            this.initializeForm = this.$formSetForm(this.dataForm , this.dataForm)
            this.initial()
        },
        watch: {
            "drivingRadio":function(newVal,oldVal){
                this.refreshData(this.paging, this.search)
            }
        },
    }
</script>

<style scoped lang="scss">
    .breaking-rate-eacharts-container {
        display: flex;

        .button-container {
            min-width: 80px;
            display: flex;
            flex-direction: column;

            .button-header {
                margin-top:20px;
                display: flex;
                justify-items: center;
                align-items: center;
                height: 20%;
                box-sizing: border-box;
                border-bottom: 2px solid #F6F6F6;
            }

            .button-footer {
                display: flex;
                align-items: center;
                height: 80%;
            }
        }

        .echarts-container {
            flex: 1;
        }
    }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/BreakingRate/index.vue"
}
</vue-filename-injector>
